/** @jsx jsx */
import React from 'react'
import { css, jsx } from '@emotion/react'
import { Icon } from '../../utils/Icon'

export type MapCurrentLocationButtonProps = {
  onClick: (e: any) => void
}

export const MapCurrentLocationButton = ({
  onClick,
}: MapCurrentLocationButtonProps) => {
  return (
    <span css={rootStyle} onClick={onClick}>
      <Icon
        iconName="current_location_button"
        style={{
          width: '48px',
          height: '48px',
        }}
      />
    </span>
  )
}

const rootStyle = css`
  display: inline-block;
  vertical-align: middle;
  z-index: 2;
  border-radius: 50%;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  & > svg {
    display: block;
  }
`
